import { h, Component } from 'preact';
import style from './style';
import idbKeyval from '../../helper.js';
import alertMessage from '../../alert.js';

export default class Timercomp extends Component {

	constructor(props) {
		super(props);

		this.state = {
			brewCount: 0,
			factor: 5,
			thresh: 0,
			time: 0,
			oldTime: 0,
		}

		this.timerStart = this.timerStart.bind(this)
		this.coundownTimer = this.coundownTimer.bind(this)
		this.plus = this.plus.bind(this)
		this.minus = this.minus.bind(this)
  }

	componentDidMount(){
		idbKeyval.get('starttime').then(val => this.setState({time: parseInt(val)}));
		idbKeyval.get('threshold').then(val => this.setState({thresh: parseInt(val)}));
		idbKeyval.get('factor').then(val => this.setState({factor: parseInt(val)}));

		let timeWindow = document.querySelector('.time')
	}

	coundownTimer(counts){
		this.setState({oldTime: counts})
		let timeWindow = document.querySelector('.time')
		let timerSec = counts * 1000
		let factorAction = this.state.factor
		let plusTimeButton = document.querySelector('.edittimerRight')
		let minusTimeButton = document.querySelector('.edittimerLeft')
		let startButton = document.querySelector('.start_button')
		timeWindow.classList.add('timer_large')

		let countDown = setInterval(function(){
			plusTimeButton.disabled = true
			minusTimeButton.disabled = true
			startButton.disabled = true
			startButton.classList.add('btn-disabled')

			if(counts >= 1){
				counts = counts - 1
				timeWindow.innerHTML = counts
			} else {
				navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
				navigator.vibrate(500);
				var audio = new Audio('/assets/din.mp3');
				audio.play();
				plusTimeButton.disabled = false
				minusTimeButton.disabled = false
				startButton.disabled = false
				startButton.classList.remove('btn-disabled')
				timeWindow.classList.remove('timer_large')
				clearInterval(countDown)
			}
		}, 1000)

		let unpdateTimer = setTimeout(function(){
			plusTimeButton.disabled = false
			minusTimeButton.disabled = false
			plusTimeButton.click()
		}, timerSec)

		this.setState({brewCount: this.state.brewCount + 1})
	}

	plus(){
		if(this.state.time != this.state.thresh){
			this.setState({oldTime: parseInt(this.state.time)})
			this.setState({time: parseInt(this.state.time) + this.state.factor})
		}else{
			alertMessage('Threshold')
			this.setState({time: parseInt(this.state.time)})
		}

	}

	minus(){
		if(this.state.time <= this.state.factor){
			alertMessage('Limit')
		}else{
			this.setState({time: parseInt(this.state.time) - this.state.factor})
		}
	}

	timerStart(){
		this.coundownTimer(this.state.time)
	}

	render({starttime}, state) {
		return (
			<section id="timer" class={style.timer}>
				<div class={style.number_wrapper}>
					<div class={"time "+style.time_style}>
						{this.state.time}
					</div>
					<div class={style.seconds}>seconds</div>

				</div>

				<div class={"brews "+style.brews_style}>
					{this.state.brewCount}
				</div>
				<div class={style.button_wrapper}>
					<button class={'editbutton edittimerLeft '+style.edittimer} onClick={this.minus}>-{this.state.factor}</button>

					<button class={'start_button btn '+style.timer_button} onClick={this.timerStart}>
						<img src="assets/play.svg" class={style.play_icon} />
					</button>

					<button class={'editbutton edittimerRight '+style.edittimer} onClick={this.plus}>+{this.state.factor}</button>
				</div>
			</section>
		);
	}


}



// WEBPACK FOOTER //
// ./components/timer/index.js